import * as Fetchers from './index';

function logMissingFetchers(fetchers, fetcherModules) {
  const missing = fetchers.filter(fetcherName => !Fetchers[fetcherName]);
  // eslint-disable-next-line no-console
  console.error(
    `Expected ${fetchers.length} fetchers but found only ${fetcherModules.length}. `,
    `Missing fetchers: [${missing.join(', ')}]`,
  );
}

export default function getEnhancementFetchers(fetchers) {
  const fetcherModules = fetchers.map(fetcherName => Fetchers[fetcherName])
    .filter(Boolean);

  if (fetcherModules.length < fetchers.length) {
    logMissingFetchers(fetchers, fetcherModules);
  }

  return fetcherModules;
}
